import logo from "../images/Rosalin-Child-Development-Centre-logo.png";
import logoWebp from "../images/Rosalin-Child-Development-Centre-logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const footer = () => {
  const placeholderLinkClassName = "footer-text-link";

  return (
    <div>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-2">
              <div className="fotAbout">
                <picture>
                  <source srcSet={logoWebp} type="image/webp" />
                  <img src={logo} alt="Rosalin Child Development Centre" width="250" height="250" />
                </picture>
              </div>
            </div>
            <div className="col-12 showMobile">
              <div className="fotLinks">
                <a href="https://www.rosalinchilddevelopment.com">Home</a>
                <a href="https://www.rosalinchilddevelopment.com/about">About Us</a>
                <a href="https://www.rosalinchilddevelopment.com/contact">Contact Us</a>
                <a href="https://www.rosalinchilddevelopment.com/job-vacancies">Job Vacancies</a>
                <span className={placeholderLinkClassName}>Portfolio</span>
                <span className={placeholderLinkClassName}>Privacy Policy</span>
                <span className={placeholderLinkClassName}>Terms & Conditions</span>
                <a href="https://www.rosalinchilddevelopment.com/book-appointment">
                  Book Appointment
                </a>
                <a href="https://www.rosalinchilddevelopment.com/occupational-therapy-in-lucknow">
                  Occupational Therapy in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/behavioral-therapy-in-lucknow">
                  Behavioral Therapy in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/cerebral-palsy-treatment-in-lucknow">
                  Cerebral Palsy Treatment in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/hyperactivity-treatment-in-lucknow">
                  Hyperactivity Treatment in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/aba-therapy-in-lucknow">
                  ABA Therapy in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/speech-therapy-in-lucknow">
                  Speech Therapy in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/services">Services</a>
                <a href="https://www.rosalinchilddevelopment.com/events">Events</a>
                <a href="https://www.rosalinchilddevelopment.com/photo-gallery">Photo Gallery</a>
                <a href="https://www.rosalinchilddevelopment.com/video-gallery">Video Gallery</a>
                <a href="https://www.rosalinchilddevelopment.com/blog">
                  Blog
                </a>
                <a href="https://www.rosalinchilddevelopment.com/client-feedback">
                  Client Feedback
                </a>
              </div>
            </div>
            <div className="col-sm-3 col-md-2 hideMobile">
              <div className="fotLinks">
                <a href="https://www.rosalinchilddevelopment.com">Home</a>
                <a href="https://www.rosalinchilddevelopment.com/about">About Us</a>
                <a href="https://www.rosalinchilddevelopment.com/contact">Contact Us</a>
                <a href="https://www.rosalinchilddevelopment.com/job-vacancies">Job Vacancies</a>
              </div>
            </div>
            <div className="col-sm-3 col-md-2 hideMobile">
              <div className="fotLinks">
                <span className={placeholderLinkClassName}>Privacy Policy</span>
                <span className={placeholderLinkClassName}>Terms & Conditions</span>
                <a href="https://www.rosalinchilddevelopment.com/book-appointment">
                  Book Appointment
                </a>
                <a href="https://www.rosalinchilddevelopment.com/services">Services</a>
              </div>
            </div>
            <div className="col-sm-3 col-md-4 hideMobile">
              <div className="fotLinks">
                <a href="https://www.rosalinchilddevelopment.com/occupational-therapy-in-lucknow">
                  Occupational Therapy in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/behavioral-therapy-in-lucknow">
                  Behavioral Therapy in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/cerebral-palsy-treatment-in-lucknow">
                  Cerebral Palsy Treatment in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/hyperactivity-treatment-in-lucknow">
                  Hyperactivity Treatment in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/aba-therapy-in-lucknow">
                  ABA Therapy in Lucknow
                </a>
                <a href="https://www.rosalinchilddevelopment.com/speech-therapy-in-lucknow">
                  Speech Therapy in Lucknow
                </a>
              </div>
            </div>
            <div className="col-sm-3 col-md-2 hideMobile">
              <div className="fotLinks">
                <a href="https://www.rosalinchilddevelopment.com/events">Events</a>
                <a href="https://www.rosalinchilddevelopment.com/photo-gallery">Photo Gallery</a>
                <a href="https://www.rosalinchilddevelopment.com/video-gallery">Video Gallery</a>
                <a href="https://www.rosalinchilddevelopment.com/blog">
                  Blog
                </a>
                <a href="https://www.rosalinchilddevelopment.com/client-feedback">
                  Client Feedback
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="fotCon">
                <p className="tbAdd">
                  <FontAwesomeIcon icon="location-dot" /> <a href="https://maps.app.goo.gl/pwRpC34aLSwzPni77" target="_blank" rel="noopener noreferrer">2/468, Vibhav Khand, Gomtinagar, Lucknow, Uttar Pradesh 226010</a>
                </p>
                <p>
                  <FontAwesomeIcon icon="mobile-screen-button" /> 8177023887, 7275504855
                </p>
                <p>
                  <a href="mailto:enquiry@rosalinchilddevelopment.com">
                    <FontAwesomeIcon icon="envelope" /> enquiry@rosalinchilddevelopment.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyRig">
        <div className="container">
          <p>
            © 2017 - {new Date().getFullYear()}, Rosalin Child Development And Rehabilitation
            Centre. All Rights Reserved
          </p>
          <p>
            Developed By{" "}
            <a href="https://www.webniter.com/" target="_blank" rel="noreferrer">
              Webniter
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default footer;
